import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import styled, { css } from 'styled-components';
import { FontAwesomeIcon } from '@vr/lib';

import BoxContainer from '../elements/BoxContainer';
import MapaContext from '../context/Mapa';
import If from './If';

const ButtonToggle = styled.button`
  position: absolute;
  border: none;
  background: transparent;
  outline: 0;
  transition: all 0.2s ease;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 3;
  color: ${({ theme }) => theme.colors.institucional};
  width: 40px;
  height: 40px;
  border-radius: 40px;
  box-shadow: 0px 0px 8px #00000029;
  font-size: 19px;
  background: #fff;
  cursor: pointer;
  &:focus,
  &:active {
    outline: 0;
  }
  ${({ open }) =>
    open
      ? css`
          top: -15px;
          right: -15px;
        `
      : css``}

  @media (max-width: ${({ theme }) => theme.devices.mobile}) {
    display: none;
  }
`;
ButtonToggle.displayName = 'ButtonToggle';

const ContentBox = styled.div`
  transition: all 0.2s ease;
  ${({ open }) =>
    open
      ? css`
          width: auto;
          height: auto;
        `
      : css`
          width: 0;
          height: 0;
          overflow: hidden;
        `}
`;

function Box({ children }) {
  const { openBox, setOpenBox, fullBox } = useContext(MapaContext);

  function toggleOpenBox() {
    if (setOpenBox) {
      setOpenBox(!openBox);
    }
  }

  return (
    <BoxContainer
      id="box-container"
      className={openBox ? 'btn-box-opened' : 'btn-box-closed'}
      expanded={openBox}
      full={fullBox}
    >
      <If test={!fullBox}>
        <ButtonToggle
          expanded={openBox}
          id="search--hidden-shown"
          onClick={toggleOpenBox}
          open={openBox}
        >
          <FontAwesomeIcon
            icon={openBox ? ['fas', 'times'] : ['fas', 'search']}
          />
        </ButtonToggle>
      </If>
      <ContentBox open={openBox}>{children}</ContentBox>
    </BoxContainer>
  );
}

Box.propTypes = {
  children: PropTypes.node,
};

Box.defaultProps = {
  children: null,
};

export default Box;
